import React from 'react'
import {Row, Col} from 'react-bootstrap';


const PasswordComplexity = ({values}) => {

    return (
        <Row className={`password-complexity`}>
        <Col className={`text-xs text-muted mt-2`}>
            <span className={values.password?.length >= 8?`text-success`:``}>Min 8 characters </span>
            <span className={values.password?.replace(/[^A-Z]/g, "").length >= 1?`text-success`:``}>including 1 uppercase </span>
            <span className={values.password?.replace(/[^0-9]/g, "").length >= 1?`text-success`:``}>& 1 number</span>
            </Col>
        </Row>
    )
}

export default PasswordComplexity;
